module.exports = __webpack_public_path__ + "img/index3.759cd919.png";